/* eslint-disable arrow-body-style */

import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {FvSensitivityActions, FvSensitivityDetailsActions} from "./fv-sensitivity.actions";
import {catchError, exhaustMap, map, of, tap} from "rxjs";
import {ErrorHandlingUtil} from "../../../shared/utils/error-handling-util";
import {FundValuationSensitivityService} from "../../services/fund-valuation-sensitivity.service";
import {ComputeSensitivitiesRequest} from "../../generated-sources/api";
import {COLUMN_TOKENS_STORAGE_KEY} from "./fv-sensitivity.state";


export const loadFundValuationSensitivityOverview = createEffect(
    (actions$ = inject(Actions),
     fundValuationSensitivityService = inject(FundValuationSensitivityService)) => {
        return actions$.pipe(
            ofType(FvSensitivityActions.load),
            exhaustMap((action) => {
                if (!action.fundId || !action.fundValuationId) {
                    return of(FvSensitivityActions.loadError({errorMsg: "Fund or Fund Valuation could not be found"}));
                }
                return fundValuationSensitivityService.getSensitivityForFundValuation(action.fundId, action.fundValuationId).pipe(
                    map((fundValuationSensitivityOverview) => FvSensitivityActions.loadSuccess({fundValuationSensitivityOverview})),
                    catchError((errorResponse: any) => of(FvSensitivityActions.loadError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                );
            })
        );
    },
    {functional: true}
);

export const computeSensitivities = createEffect(
    (actions$ = inject(Actions),
     fundValuationSensitivityService = inject(FundValuationSensitivityService)) => {
        return actions$.pipe(
            ofType(FvSensitivityActions.compute),
            exhaustMap((action) => {
                if (!action.fundId || !action.fundValuationId) {
                    return of(FvSensitivityActions.computeError({errorMsg: "Fund or Fund Valuation could not be found"}));
                }
                const request: ComputeSensitivitiesRequest = {
                    step: action.step,
                    steps: action.steps,
                    paramType: action.paramType
                };
                return fundValuationSensitivityService.computeSensitivitiesForFundValuation(action.fundId, action.fundValuationId, request).pipe(
                    map((fundValuationSensitivityOverview) => FvSensitivityActions.computeSuccess({fundValuationSensitivityOverview})),
                    catchError((errorResponse: any) => of(FvSensitivityActions.computeError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                );
            })
        );
    },
    {functional: true}
);

export const loadFundValuationSensitivityDetails = createEffect(
    (actions$ = inject(Actions),
     fundValuationSensitivityService = inject(FundValuationSensitivityService)) => {
        return actions$.pipe(
            ofType(FvSensitivityDetailsActions.load),
            exhaustMap((action) => {
                if (!action.fundId || !action.fundValuationId || !action.fundValuationSensitivityId) {
                    return of(FvSensitivityDetailsActions.loadError({errorMsg: "Fund, Fund Valuation or Sensitivity could not be found"}));
                }
                return fundValuationSensitivityService.getSensitivityDetailsForFundValuation(action.fundId, action.fundValuationId, action.fundValuationSensitivityId).pipe(
                    map((fundValuationSensitivity) => FvSensitivityDetailsActions.loadSuccess({fundValuationSensitivity})),
                    catchError((errorResponse: any) => of(FvSensitivityDetailsActions.loadError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                );
            })
        );
    },
    {functional: true}
);

export const persistColumnTokens = createEffect(
    (actions$ = inject(Actions)) =>
        actions$.pipe(
            ofType(FvSensitivityActions.setColumnTokens),
            tap(({tokens}) => localStorage.setItem(COLUMN_TOKENS_STORAGE_KEY, JSON.stringify(tokens)))
        ),
    {functional: true, dispatch: false}
);
